module.exports = __webpack_public_path__ + "static/media/as7sj.57f7fc88.png";